import lazy from './lazy.js'
import equalizeInlineFilters from './equalize-inline-filters.js'
import scrollReveal from './scroll-reveal.js'

const htmxEvents = {
    init() {
        if (typeof htmx !== 'undefined') {
            this.setupScrollBehavior();
            this.setupLoadingStates();
        }
    },

    setupScrollBehavior() {
        htmx.on('htmx:afterSwap', function(event) {
            // Try to find sprig container related to this specific event
            let container = null;

            // First, check if the target itself is the sprig container
            if (event.detail.target && event.detail.target.id === 'sprig-container') {
                container = event.detail.target;
            }

            if (event.detail?.target?.querySelector('#sprig-container')) {
                container = event.detail.target.querySelector('#sprig-container');
            }

            if (!container) return;

            const top = container.offsetTop - 120;

            setTimeout(() => {
                window.scrollTo({top: (top || 0), behavior: 'smooth'});
            }, 20);
        });
    },

    setupLoadingStates() {
        htmx.on('htmx:beforeRequest', function(event) {
            event.detail.target.classList.add('is-loading');
        });

        htmx.on('htmx:afterRequest', function(event) {
            event.detail.target.classList.remove('is-loading');
            equalizeInlineFilters.refresh(event.detail.target);
            scrollReveal.refresh(event.detail.target);
            lazy.refresh(event.detail.target);
        });
    }
};

export default htmxEvents;
